export default __webpack_public_path__ + "static/SR France - Process Flow Chart - Burnt Sugars-0e9fe9786ff5767cad5d4ed4048090da.pdf";